import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const ErrorSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM9.84389 7.02455C10.9925 7.02455 11.9235 6.0916 11.9235 4.94074C11.9235 3.78989 10.9925 2.85693 9.84389 2.85693C8.69533 2.85693 7.76424 3.78989 7.76424 4.94074C7.76424 6.0916 8.69533 7.02455 9.84389 7.02455ZM12.2353 14.5235C12.0698 14.5235 11.9111 14.4577 11.794 14.3405C11.677 14.2234 11.6111 14.0645 11.6108 13.8987V9.13681C11.6108 8.97111 11.5451 8.8122 11.4282 8.69503C11.3113 8.57787 11.1527 8.51204 10.9873 8.51204H7.76707C7.6017 8.51204 7.44311 8.57787 7.32618 8.69503C7.20925 8.8122 7.14355 8.97111 7.14355 9.13681V9.55395C7.14355 9.71965 7.20925 9.87856 7.32618 9.99572C7.44311 10.1129 7.6017 10.1787 7.76707 10.1787C7.93244 10.1787 8.09103 10.2445 8.20796 10.3617C8.32489 10.4789 8.39058 10.6378 8.39058 10.8035V13.9035C8.39058 14.0692 8.32489 14.2281 8.20796 14.3452C8.09103 14.4624 7.93244 14.5282 7.76707 14.5282C7.6017 14.5282 7.44311 14.5941 7.32618 14.7112C7.20925 14.8284 7.14355 14.9873 7.14355 15.153V15.5701C7.14481 15.735 7.21105 15.8927 7.32785 16.0088C7.44465 16.125 7.60252 16.1901 7.76707 16.1901H12.2343C12.3162 16.1901 12.3973 16.174 12.4729 16.1426C12.5486 16.1112 12.6173 16.0652 12.6752 16.0072C12.7331 15.9491 12.779 15.8803 12.8104 15.8045C12.8417 15.7287 12.8578 15.6474 12.8578 15.5654V15.1482C12.8578 14.9827 12.7923 14.8239 12.6756 14.7068C12.5588 14.5897 12.4005 14.5237 12.2353 14.5235Z"
        fill="#F4381F"
      />
    </svg>
  </span>
);

export default ErrorSVG;
